import PropTypes from 'prop-types';
import * as React from 'react';
import {Route, Routes} from 'react-router-dom';

import {AppLayoutContainer} from './AppLayoutContainer';

const LoggedInLayout = ({config}) => (
  <Routes>
    <Route path={'*'} element={<AppLayoutContainer config={config} />} />
  </Routes>
);

LoggedInLayout.displayName = 'LoggedInLayout';

LoggedInLayout.propTypes = {
  config: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default LoggedInLayout;
